<h3 class="text-lg font-semibold mb-4">
  {{ key() | transloco }}
</h3>
<p-divider />
